var voted_users_rtlignore_default = {
  "container": "pUZed",
  "webview": "t3nww",
  "avatar_list": "iaPaQ",
  "avatar": "BYIXx",
  "user_avatar": "xCn9R",
  "modal": "JvRk7",
  "voted_users_modal": "_7voE5",
  "overlay": "mBMQN",
  "user_card": "qiR7Z",
  "user_name": "_7a2pP",
  "voted_users_modal_header": "eabDv",
  "cta": "XkbN9",
  "close_icon": "_-8wUm",
  "title": "PkjpH",
  "member_list_container": "XHzYX",
  "member_list": "_9qeWH",
  "loader": "-mL45",
  "anonymous_counter": "TiJg4",
  "spinner": "h1KQS",
  "spin": "tGu2d"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
